/* toki-sponsored-wheel.part4.js — wild spin, audio choreography, toaster pops, goo return, side cannons */
(function(){
  'use strict';
  var W=window.TokiSponsoredWheelEngine,U=W&&W.util;
  if(!W||!U||W.__part4Loaded) return;
  W.__part4Loaded=true;

  function later(inst,fn,ms){ var id=setTimeout(fn,ms); inst.rt.timers.push(id); return id; }
  function clearTimers(inst){ (inst.rt.timers||[]).forEach(clearTimeout); inst.rt.timers=[]; }
  function setStatus(inst,text){ if(inst.refs.status) inst.refs.status.textContent=text; }
  function setBusy(inst,on){
    inst.refs.spin.disabled=!!on; inst.refs.hit.disabled=!!on;
    inst.host.classList.toggle('ggw-isBusy',!!on);
  }
  function vibe(pattern){ try{ if(navigator.vibrate) navigator.vibrate(pattern); }catch(_){ } }

  function ensureAudio(inst){
    if(inst.audioBus) return inst.audioBus;
    var a=new Audio();
    a.preload='auto';
    a.playsInline=true;
    a.setAttribute('playsinline','');
    a.setAttribute('webkit-playsinline','');
    inst.audioBus=a;
    inst.rt.audioToken=0;
    inst.rt.audioKey='';
    return a;
  }

  function play(inst,k){
    var a=ensureAudio(inst),cfg=inst.cfg.sounds[k];
    var token=++inst.rt.audioToken;
    inst.rt.audioKey=k;

    try{
      a.pause();
      a.removeAttribute('src');
      a.load();
      a.src=cfg.url;
      a.preload='auto';
      a.currentTime=0;
      a.muted=false;
      a.volume=k==='win'?.95:.9;

      var p=a.play();
      if(p&&p.catch){
        p.catch(function(err){
          console.warn('[Grit Goo wheel] audio play blocked for '+k,err);
        });
      }
    }catch(err){
      console.warn('[Grit Goo wheel] audio error for '+k,err);
    }

    later(inst,function(){
      if(inst.rt.audioToken!==token || inst.rt.audioKey!==k) return;
      try{
        a.pause();
        a.currentTime=0;
      }catch(_){ }
    },cfg.clipMs+120);
  }

  function stop(inst,k){
    if(inst.rt.audioKey!==k) return;
    try{
      var a=inst.audioBus;
      if(a){
        ++inst.rt.audioToken;
        a.pause();
        a.currentTime=0;
      }
    }catch(_){ }
  }

  W.audioUnlock=function(){ return true; };

  function vecTransform(inst,idx,pop,scale,rot){
    var v=inst.refs.sliceVecs[idx]||{x:0,y:0}, node=inst.refs.sliceNodes[idx]; if(!node) return;
    node.setAttribute('transform','translate('+(v.x*pop).toFixed(2)+' '+(v.y*pop).toFixed(2)+') scale('+scale.toFixed(3)+') rotate('+(rot||0).toFixed(2)+' 500 500)');
  }
  function resetSlices(inst){
    (inst.refs.sliceNodes||[]).forEach(function(n){n.classList.remove('ggw-winnerSlice','ggw-gooReturn');n.removeAttribute('transform');});
  }
  function aliveSlices(inst,t,p){
    var mid=1-Math.abs(.5-p)*2,amp=24+mid*62;
    inst.refs.sliceNodes.forEach(function(node,i){
      var v=inst.refs.sliceVecs[i], phase=i*.83+t/74, pulse=.5+.5*Math.sin(phase), pop=(.42+.58*pulse)*amp;
      var shear=Math.sin(t/31+i)*5.5, sc=1+pulse*(.035+mid*.04);
      node.setAttribute('transform','translate('+(v.x*pop+shear).toFixed(2)+' '+(v.y*pop-shear*.45).toFixed(2)+') scale('+sc.toFixed(3)+')');
    });
  }

  function targetDeg(inst,idx,turns){
    var n=inst.cfg.segments.length,step=360/n,current=U.normDeg(inst.rt.wheelDeg||0),target=U.normDeg(90-idx*step),delta=U.normDeg(target-current);
    return current+turns*360+delta;
  }

  function wildSpin(inst,idx,done){
    var start=U.normDeg(inst.rt.wheelDeg||0), end=targetDeg(inst,idx,63), dur=5000, step=360/inst.cfg.segments.length, t0=performance.now();
    inst.rt.phase='spin'; inst.host.classList.add('ggw-spinning'); play(inst,'spin'); setStatus(inst,'THE WASTELAND IS CHEWING ON YOUR FATE…');
    function frame(t){
      var p=U.clamp((t-t0)/dur,0,1),deg;
      if(p<.08){
        var a=p/.08; deg=start+(end-start)*.25*U.easeOutQuint(a)+Math.sin(t/8)*step*.22;
      }else if(p<.28){
        var b=(p-.08)/.20; deg=start+(end-start)*(.25+.31*U.easeOutQuint(b))+Math.sin(t/9)*step*(.27-.10*b);
      }else if(p<.49){
        var c=(p-.28)/.21; deg=start+(end-start)*(.56+.17*U.easeInOutCubic(c))+Math.sin(t/5.8)*step*.14+Math.sin(t/17)*step*.22;
      }else if(p<.69){
        var d=(p-.49)/.20; deg=start+(end-start)*(.73+.14*d)+Math.sin(t/7.4)*step*(.34-.12*d);
      }else if(p<.88){
        var e=(p-.69)/.19, base=start+(end-start)*(.87+.09*e), amp=(.55-.34*e)*step;
        deg=base+Math.sin(t/8.2)*amp+Math.sin(t/3.9)*amp*.27;
      }else if(p<.965){
        var f=(p-.88)/.085; deg=end-step*.19+step*.17*U.easeOutQuint(f)+Math.sin(f*Math.PI*11)*(1-f)*step*.12;
      }else{
        var g=(p-.965)/.035; deg=end-step*.02+(step*.02)*U.easeOutBack(g);
      }
      W.setWheelDeg(inst,deg);
      // Per-slice SVG transforms force Safari to repaint the entire wheel each frame.
      // Keep the effect everywhere else, but let Apple retain the smooth composited spin.
      if(!inst.rt.applePerf) aliveSlices(inst,t,p);
      inst.refs.fx.style.setProperty('--ggw-surge',String(Math.min(1,.18+Math.abs(Math.sin(t/42))*.72+p*.25)));
      if(p<1) inst.rt.raf=requestAnimationFrame(frame); else {
        W.setWheelDeg(inst,end);
        resetSlices(inst);
        inst.host.classList.remove('ggw-spinning');
        if(inst.rt.applePerf&&inst.refs.svg) inst.refs.svg.style.willChange='';
        done();
      }
    }
    inst.rt.raf=requestAnimationFrame(frame);
  }

  function toasterPop(inst,idx,strong){
    var node=inst.refs.sliceNodes[idx]; if(!node) return;
    node.classList.add('ggw-winnerSlice');
    var peak=strong?112:92;
    vecTransform(inst,idx,14,1.035,0);
    requestAnimationFrame(function(){
      vecTransform(inst,idx,peak,strong?1.27:1.21,strong?-2.5:2.2); vibe(strong?[28,24,36]:24);
      later(inst,function(){ vecTransform(inst,idx,peak*.58,1.12,strong?1.2:-1.1); },115);
      later(inst,function(){ vecTransform(inst,idx,peak*.74,1.16,strong?-1.1:1); },245);
    });
  }

  function loadConfettiImage(inst,cb){
    if(inst.images.confetti && inst.images.confetti.complete){ cb(inst.images.confetti); return; }
    var im=new Image(); im.crossOrigin='anonymous'; im.onload=function(){inst.images.confetti=im;cb(im);}; im.onerror=function(){cb(null);}; im.src=inst.cfg.confettiImageUrl;
  }
  function doubleCannons(inst,idx,onSecondBurst){
    var canvas=inst.refs.confetti,color=inst.cfg.segments[idx].color;
    var apple=!!inst.rt.applePerf;
    var vw=Math.max(1,window.innerWidth||document.documentElement.clientWidth||1);
    var vh=Math.max(1,window.innerHeight||document.documentElement.clientHeight||1);
    /* Safari's full Retina canvas was the main confetti bottleneck. Keep the
       same double-cannon composition, but cap only the backing resolution. */
    var dpr=Math.max(1,Math.min(devicePixelRatio||1,apple?1.25:1.75));

    canvas.hidden=false;
    canvas.width=Math.floor(vw*dpr);
    canvas.height=Math.floor(vh*dpr);
    canvas.style.width=vw+'px';
    canvas.style.height=vh+'px';

    var ctx=canvas.getContext('2d',{alpha:true});
    ctx.setTransform(dpr,0,0,dpr,0,0);

    loadConfettiImage(inst,function(im){
      var sprite=null;
      if(im){
        /* Draw a small cached sprite instead of resampling the large source
           image hundreds of times per frame on WebKit. */
        sprite=document.createElement('canvas');
        sprite.width=96; sprite.height=96;
        var sctx=sprite.getContext('2d',{alpha:true});
        sctx.drawImage(im,0,0,96,96);
      }

      var parts=[], start=performance.now(), secondFired=false;
      var endAt=apple?5600:6500, last=start;

      function addBurst(power){
        /* Preserve the full visual recipe on Apple while using a saner particle
           budget. Larger pieces compensate visually for the reduced count. */
        var perSide=apple?72:108;
        for(var side=0;side<2;side++){
          for(var i=0;i<perSide;i++){
            var dir=side===0?1:-1;
            var useImage=!!sprite && U.rand01()<(apple?.52:.60);
            parts.push({
              x:side===0?-34:vw+34,
              y:vh*(.60+U.rand01()*.22),
              vx:dir*((4.2+U.rand01()*8.8)*power),
              vy:-((5.4+U.rand01()*10.5)*power),
              g:.075+U.rand01()*.075,
              r:U.rand01()*6.28,
              vr:(U.rand01()-.5)*.12,
              s:useImage?((apple?34:30)+U.rand01()*(apple?54:52)):(10+U.rand01()*20),
              img:useImage,
              alpha:1,
              shape:Math.floor(U.rand01()*3)
            });
          }
        }
        vibe(power>1?[30,22,38]:[22,18,28]);
      }

      addBurst(1);

      function drawColorPiece(p){
        ctx.fillStyle=color;
        if(p.shape===0){
          ctx.fillRect(-p.s/2,-p.s*.18,p.s,p.s*.36);
        }else if(p.shape===1){
          ctx.beginPath();
          ctx.arc(0,0,p.s*.38,0,Math.PI*2);
          ctx.fill();
        }else{
          ctx.beginPath();
          ctx.moveTo(0,-p.s*.5);
          ctx.lineTo(p.s*.46,p.s*.42);
          ctx.lineTo(-p.s*.46,p.s*.42);
          ctx.closePath();
          ctx.fill();
        }
      }

      function frame(t){
        var elapsed=t-start;
        var dt=Math.min(2.2,Math.max(.35,(t-last)/16.667));
        last=t;

        if(!secondFired && elapsed>=1500){
          secondFired=true;
          addBurst(1.05);
          if(typeof onSecondBurst==='function') onSecondBurst();
        }

        ctx.clearRect(0,0,vw,vh);
        var live=0;
        for(var n=0;n<parts.length;n++){
          var p=parts[n];
          p.vy+=p.g*dt;
          p.x+=p.vx*dt;
          p.y+=p.vy*dt;
          p.r+=p.vr*dt;
          p.alpha*=Math.pow(.9975,dt);
          if(p.alpha>.045 && p.y<vh+150 && p.x>-180 && p.x<vw+180){
            live++;
            ctx.save();
            ctx.globalAlpha=p.alpha;
            ctx.translate(p.x,p.y);
            ctx.rotate(p.r);
            if(p.img) ctx.drawImage(sprite,-p.s/2,-p.s/2,p.s,p.s);
            else drawColorPiece(p);
            ctx.restore();
          }
        }

        if(elapsed<endAt || live){
          requestAnimationFrame(frame);
        }else{
          ctx.clearRect(0,0,vw,vh);
          canvas.hidden=true;
        }
      }
      requestAnimationFrame(frame);
    });
  }

  function buildQrUrl(inst,idx){
    return (inst.cfg.qrDataUris&&inst.cfg.qrDataUris[idx]) || '';
  }

  function lockWinnerViewport(inst){
    /* Intentionally do not alter html/body positioning or overflow.
       Shopify homepages may reset their scroll container to the top when
       either element is locked. The fixed modal backdrop already captures
       interaction and contains overscroll on its own. */
    inst.rt.lockedScrollY=window.scrollY||window.pageYOffset||0;
  }

  function unlockWinnerViewport(inst){
    /* No document styles were changed, so the wheel remains exactly where
       it was and no restoration scroll is required. */
  }

  function openWinner(inst,idx){
    var r=inst.refs,s=inst.cfg.segments[idx];
    inst.rt.phase='winner';
    play(inst,'win');
    toasterPop(inst,idx,true);

    function revealWinner(){
      toasterPop(inst,idx,false);
      r.modal.innerHTML='';
      r.modalBack.hidden=false;
      lockWinnerViewport(inst);
      inst.host.classList.add('ggw-winnerOpen');

      var close=U.el('button',{class:'ggw-modal__x',type:'button','aria-label':'Close result'},['×']);
      var sticker=U.el('img',{class:'ggw-modal__sticker',src:s.img,alt:s.label});
      var qrWrap=U.el('a',{class:'ggw-qr',href:inst.cfg.siteUrl,target:'_blank',rel:'noopener','aria-label':'Visit Grit Goo'},[
        U.el('img',{class:'ggw-qr__code',src:buildQrUrl(inst,idx),alt:'QR code to gritgoo.com'}),
        U.el('span',{class:'ggw-qr__logoWrap'},[U.el('img',{class:'ggw-qr__logo',src:inst.cfg.logoUrl,alt:''})])
      ]);

      r.modal.style.setProperty('--ggw-win',s.color);
      r.modal.appendChild(close);
      r.modal.appendChild(U.el('div',{class:'ggw-modal__kicker',text:'WASTELAND PICK'}));
      r.modal.appendChild(sticker);
      r.modal.appendChild(U.el('h3',{class:'ggw-modal__name',text:s.label}));
      r.modal.appendChild(U.el('p',{class:'ggw-modal__copy',text:'You got '+s.label+'. Scan the goo mark and enter the wasteland.'}));
      r.modal.appendChild(qrWrap);
      r.modal.appendChild(U.el('div',{class:'ggw-modal__url',text:'GRITGOO.COM'}));

      function returnGoo(){
        if(inst.rt.phase==='return') return;
        inst.rt.phase='return';
        r.modalBack.hidden=true;
        unlockWinnerViewport(inst);
        inst.host.classList.remove('ggw-winnerOpen');
        play(inst,'back');
        setStatus(inst,'STICKING THE GOO BACK TOGETHER…');

        var node=r.sliceNodes[idx];
        node.classList.add('ggw-gooReturn');
        var v=r.sliceVecs[idx],start=performance.now(),dur=1650;

        function frame(t){
          var p=U.clamp((t-start)/dur,0,1),pop,sc,rot;
          if(p<.34){
            var a=p/.34;
            pop=72-(55*U.easeOutQuint(a));
            sc=1.16-.08*a;
            rot=Math.sin(a*Math.PI*2)*3;
          }else if(p<.60){
            var b=(p-.34)/.26;
            pop=17+Math.sin(b*Math.PI)*52;
            sc=1.08+.09*Math.sin(b*Math.PI);
            rot=-Math.sin(b*Math.PI)*4;
          }else if(p<.83){
            var c=(p-.60)/.23;
            pop=17+Math.sin(c*Math.PI*5)*(1-c)*18;
            sc=1.08+Math.sin(c*Math.PI*4)*(1-c)*.06;
            rot=Math.sin(c*Math.PI*6)*(1-c)*3;
          }else{
            var d=(p-.83)/.17;
            pop=17*(1-U.easeOutBack(d));
            sc=1.08-.08*U.easeOutBack(d);
            rot=Math.sin(d*Math.PI*3)*(1-d)*2;
          }

          node.setAttribute(
            'transform',
            'translate('+(v.x*pop).toFixed(2)+' '+(v.y*pop).toFixed(2)+') scale('+sc.toFixed(3)+') rotate('+rot.toFixed(2)+' 500 500)'
          );

          if(p<1){
            requestAnimationFrame(frame);
          }else{
            resetSlices(inst);
            inst.rt.phase='idle';
            setBusy(inst,false);
            setStatus(inst,'Tap the wheel or smash the button.');
          }
        }
        requestAnimationFrame(frame);
      }

      close.onclick=returnGoo;
      r.modalBack.onclick=function(e){
        if(e.target===r.modalBack) returnGoo();
      };
    }

    doubleCannons(inst,idx,revealWinner);
  }

  function start(inst){
    if(inst.rt.spinning||inst.rt.phase!=='idle') return;
    clearTimers(inst); ensureAudio(inst); setBusy(inst,true); resetSlices(inst); inst.rt.spinning=true; inst.rt.phase='pre';
    setStatus(inst,'WAKE THE GOO…'); play(inst,'pre'); inst.host.classList.add('ggw-preSpin'); vibe([18,30,18]);
    later(inst,function(){
      inst.host.classList.remove('ggw-preSpin'); stop(inst,'pre'); var idx=U.pickIndex(inst.cfg.segments); inst.rt.chosenIdx=idx;
      wildSpin(inst,idx,function(){ inst.rt.spinning=false; openWinner(inst,idx); });
    },5000);
  }

  W.bind=function(inst){
    if(inst.__bound) return; inst.__bound=true; var lastTouch=0;
    function fire(e){ if(e&&e.type==='click'&&Date.now()-lastTouch<650) return; start(inst); }
    inst.refs.spin.addEventListener('click',fire);
    inst.refs.hit.addEventListener('pointerdown',function(e){if(e.pointerType==='touch')lastTouch=Date.now();e.preventDefault();fire(e);},{passive:false});
    inst.refs.hit.addEventListener('touchstart',function(e){lastTouch=Date.now();e.preventDefault();fire(e);},{passive:false});
    inst.refs.hit.addEventListener('click',fire);
    inst.refs.hit.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();fire(e);}});
  };
})();
